























































import { Component, PropSync, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { MessageService } from "@/shared/services/message-service";
import { ProcessoNums } from "./ProcessoNums";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import { datos_adicionales_producto } from "@/shared/dtos/datos_adicionales_producto";
import { UtilsString } from "@/utils/utils-string";
@Component({
  components: {
    ConfirmDialog,
  },
})
export default class ProcesoDevolucion extends Vue {
  @PropSync("id", { default: -1 }) id_prodcuto!: number;
  @PropSync("show", { default: false }) Xshow!: boolean;
  public selectedRow: producto = new producto();
  public persona_reserva: string = "";
  public _datos_adicionales: datos_adicionales_producto =
    new datos_adicionales_producto();

  async created() {
    if (!(productoModule.productos.length > 0)) {
      await productoModule.getproductos();
    }
    this.selectedRow = productoModule.productos.find(
      (x) => x.id === this.id_prodcuto
    )!;

    await datos_adicionales_productoModule.getdatos_adicionales_productoById(
      this.selectedRow.id
    );
  }

  get Ganacias() {
    return (
      this.selectedRow.precio_vendido - this.selectedRow.coste_compra
    ).toFixed(2);
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }

  get datos_adicionales_base_de_datos() {
    return datos_adicionales_productoModule.datos_adicionales_producto;
  }

  async aceptar() {
    this.selectedRow.estado = ProcessoNums.Disponible;
    this.selectedRow.precio_vendido = 0;
    this.selectedRow.vendido = false;
    this._datos_adicionales = new datos_adicionales_producto();

    this._datos_adicionales.tipo_registro = ProcessoNums.Devolucion;
    this._datos_adicionales.id_prodcuto = this.selectedRow.id;
    this._datos_adicionales.texto = this.persona_reserva;
    try {
      await datos_adicionales_productoModule.guardardatos_adicionales_producto(
        this._datos_adicionales
      );
    } catch (error) {
      console.log(error);
    }
    try {
      await datos_adicionales_productoModule.eliminardatos_adicionales_producto(
        this.datos_adicionales_base_de_datos
      );
    } catch (error) {
      console.log(error);
    }
    try {
      productoModule.modificarproducto(this.selectedRow).then(() => {
        this.cancelar();
        MessageService.toast("Devolución realizada con éxito");
        productoModule.getproductos();
      });
    } catch (error) {
      console.log(error);
    }
  }
  cancelar() {
    this.Xshow = false;
  }
}
